{
	"access_description": "Key requests, account access, and plans will be available here.",
	"access_eyebrow": "Coming next",
	"access_link": "Request access",
	"access_status": "The portal foundation is ready.",
	"access_title": "Your developer account, in one place.",
	"account": {
		"billing_access_until": "Access until {{date}}",
		"billing_period_unavailable": "The current billing period is not available.",
		"billing_portal_error": "Subscription management could not be opened. Try again.",
		"billing_renews": "Renews {{date}}",
		"billing_status_active": "Active",
		"billing_status_canceled": "Canceled",
		"billing_status_past_due": "Payment due",
		"billing_status_synchronized": "Synchronized",
		"billing_status_trialing": "Trial",
		"danger_description": "Account deletion is permanent and ends access to the developer portal.",
		"danger_irreversible": "Deletion is irreversible and the account cannot be recovered.",
		"danger_no_refund": "Previously paid time is not automatically refunded.",
		"danger_revoke_access": "Every API key and session will be revoked.",
		"danger_stop_renewal": "Any active subscription will stop renewing before deletion.",
		"danger_title": "Danger zone",
		"delete_account": "Delete account",
		"delete_billing_error": "Deletion could not stop subscription renewal. Your account is still active. Retry when you are ready.",
		"delete_code_description": "Enter the six-digit code sent to your verified email address.",
		"delete_code_invalid": "The code is invalid or expired. Try again or request a new code.",
		"delete_code_invalid_format": "Enter the six-digit code.",
		"delete_code_label": "Confirmation code",
		"delete_code_title": "Confirm account deletion",
		"delete_confirmation_phrase": "DELETE",
		"delete_cooldown_error": "Wait {{seconds}} seconds before requesting another code.",
		"delete_deleting": "Deleting...",
		"delete_dialog_phrase_description": "This account has no verified email. Type the exact confirmation phrase before deleting it immediately.",
		"delete_dialog_title": "Delete your account?",
		"delete_dialog_verified_description": "We will send a confirmation code only after you continue. Nothing is deleted until you enter that code.",
		"delete_generic_error": "The account could not be deleted. Your account and access remain unchanged. Try again.",
		"delete_phrase_exact": "Capitalization must match exactly.",
		"delete_phrase_instruction": "Type the following phrase to continue:",
		"delete_phrase_invalid": "Type the confirmation phrase exactly as shown.",
		"delete_phrase_label": "Confirmation phrase",
		"delete_resend": "Send a new code",
		"delete_resend_cooldown": "Resend in {{seconds}}s",
		"delete_retry": "Retry deletion",
		"delete_send_code": "Send confirmation code",
		"delete_token_stale": "This confirmation session has expired. Send a new code to continue.",
		"email_change_action": "Change email",
		"email_change_code_invalid": "One or both codes are invalid or expired. Check them and try again, or request new codes.",
		"email_change_code_invalid_format": "Enter the six-digit code.",
		"email_change_codes_description_single": "Enter the code sent to {{newEmail}}.",
		"email_change_codes_description_two": "Enter the codes sent to {{newEmail}} and your current email address.",
		"email_change_codes_expire": "Codes expire shortly and can be used only once.",
		"email_change_codes_title": "Check your inbox",
		"email_change_confirm": "Confirm email change",
		"email_change_confirming": "Confirming...",
		"email_change_cooldown_error": "Wait {{seconds}} seconds before requesting new codes.",
		"email_change_current_code_label": "Code sent to current email",
		"email_change_description": "Enter the new address. We will verify the new inbox and, when required, your current inbox before anything changes.",
		"email_change_email_invalid": "Enter a valid email address.",
		"email_change_email_required": "Enter your new email address.",
		"email_change_generic_error": "The email change could not be completed. Your current email is unchanged. Try again.",
		"email_change_new_code_label": "Code sent to new email",
		"email_change_new_email_label": "New email address",
		"email_change_new_email_placeholder": "new@example.com",
		"email_change_ownership_error": "That email is already connected to another account. Use a different address.",
		"email_change_resend": "Send new codes",
		"email_change_resend_cooldown": "Resend in {{seconds}}s",
		"email_change_retry_cooldown": "Try again in {{seconds}}s",
		"email_change_same_email": "Enter an email different from your current address.",
		"email_change_send_codes": "Send verification codes",
		"email_change_title": "Change email address",
		"email_change_token_stale": "This verification session has expired. Send new codes to continue.",
		"email_change_use_another": "Use another email",
		"email_label": "Email",
		"email_missing": "No email",
		"email_missing_value": "No verified email address",
		"email_unverified": "Unverified",
		"email_unverified_value": "Email verification pending",
		"email_verified": "Verified",
		"free_plan": "Free plan",
		"free_plan_description": "No synchronized paid subscription is active.",
		"identity_description": "The verified identity associated with this developer account.",
		"identity_title": "Account identity",
		"language_description": "Choose the language used throughout the portal.",
		"language_invalid": "Choose a supported language.",
		"language_label": "Interface language",
		"language_saved": "Interface language saved.",
		"language_title": "Language",
		"manage_billing": "Manage subscription",
		"member_since": "Member since",
		"password_add_email_first": "Add and verify an email address before setting a password.",
		"password_change_action": "Change password",
		"password_change_description": "Every other active session will be signed out after this password changes. Your current session will stay active.",
		"password_change_title": "Change password",
		"password_configured": "Configured",
		"password_confirm_label": "Confirm new password",
		"password_confirm_required": "Confirm your new password.",
		"password_current_invalid": "The current password is incorrect. Try again.",
		"password_current_label": "Current password",
		"password_current_required": "Enter your current password.",
		"password_description": "Use a strong, unique password to protect this developer account.",
		"password_generic_error": "The password could not be updated. Try again without sharing any security codes.",
		"password_label": "Password",
		"password_mismatch": "The passwords do not match.",
		"password_new_description": "Use at least 8 characters.",
		"password_new_label": "New password",
		"password_new_min": "Use at least 8 characters.",
		"password_not_configured": "Not configured",
		"password_otp_code_label": "Email code",
		"password_otp_description": "We will send an eight-character verification code to your verified email before you set a password.",
		"password_otp_invalid": "The email code is invalid or expired. Check it and try again.",
		"password_otp_invalid_format": "Enter the eight-character code from your email.",
		"password_otp_resend": "Send a new code",
		"password_otp_send": "Send verification code",
		"password_otp_send_error": "The verification code could not be sent. Try again.",
		"password_otp_token_stale": "This verification session has expired. Send a new code to continue.",
		"password_save": "Update password",
		"password_saving": "Updating...",
		"password_set_action": "Set password",
		"password_set_title": "Set password",
		"password_success": "Password updated successfully.",
		"password_totp_invalid": "That authenticator code is invalid. Wait for a fresh code and try again.",
		"password_verify_email_first": "Verify your email address before setting a password.",
		"plan_current": "Current",
		"plan_description": "Review the plan synchronized with your billing account.",
		"plan_error": "Plan details could not be loaded.",
		"plan_loading": "Loading plan details",
		"plan_title": "Plan",
		"preferences_description": "Language and analytics timezone are saved independently.",
		"preferences_error": "Preferences could not be loaded.",
		"preferences_loading": "Loading preferences",
		"preferences_save_error": "The preference could not be saved. Try again.",
		"preferences_title": "Preferences",
		"retry": "Retry",
		"retrying": "Retrying...",
		"save_language": "Save language",
		"save_time_zone": "Save timezone",
		"security_description": "A summary of the authentication methods and sessions protecting this account.",
		"security_title": "Security",
		"session_cancel": "Cancel",
		"session_current": "Current device",
		"session_device_browser_os": "{{browser}} on {{os}}",
		"session_device_unknown": "Unknown device",
		"session_last_active": "Active {{date}}",
		"session_location_unknown": "Approximate location unavailable",
		"session_revoke": "Revoke",
		"session_revoke_description": "This device will be signed out. Your current session will stay active.",
		"session_revoke_error": "The session could not be revoked. Try again.",
		"session_revoke_label": "Revoke {{device}}",
		"session_revoke_title": "Revoke session?",
		"session_revoking": "Revoking...",
		"session_source_anonymous": "Guest session",
		"session_source_email_otp": "Email code",
		"session_source_impersonate": "Support access",
		"session_source_magic_link": "Magic link",
		"session_source_oauth": "Social sign-in",
		"session_source_passkey": "Passkey",
		"session_source_password": "Password",
		"session_source_password_reset": "Password reset",
		"sessions_description": "Review devices with access to this developer account.",
		"sessions_error": "Sessions could not be loaded.",
		"sessions_label": "Active sessions",
		"sessions_loading": "Loading active sessions",
		"sessions_one": "1 active session",
		"sessions_other": "{{count}} active sessions",
		"sessions_retry": "Retry sessions",
		"sessions_revoke_others": "Sign out all other sessions",
		"sessions_revoke_others_confirm": "Sign out others",
		"sessions_revoke_others_description": "Every other device will be signed out. Your current device will stay signed in.",
		"sessions_revoke_others_title": "Sign out all other sessions?",
		"subtitle": "Manage your developer identity, security, preferences, and plan.",
		"time_zone_description": "Use local calendar boundaries for API analytics.",
		"time_zone_hint": "Choose an IANA timezone.",
		"time_zone_invalid": "Choose a valid IANA timezone.",
		"time_zone_label": "Analytics timezone",
		"time_zone_required": "Choose a timezone.",
		"time_zone_saved": "Analytics timezone saved.",
		"time_zone_title": "Timezone",
		"title": "Account",
		"totp_code_invalid_format": "Enter the six-digit code from your authenticator app.",
		"totp_code_label": "Authenticator code",
		"totp_continue": "Continue",
		"totp_description": "Use an authenticator app to protect sign-in with a time-based code.",
		"totp_device_label": "Authenticator",
		"totp_device_limit_error": "You have reached the authenticator limit. Remove an existing authenticator before adding another.",
		"totp_device_required": "Choose an authenticator.",
		"totp_disable": "Disable two-factor",
		"totp_disable_description": "Future sign-ins will no longer require an authenticator code. Your enrolled authenticators will remain connected.",
		"totp_disable_generic_error": "Two-factor authentication could not be disabled. Try again.",
		"totp_disable_invalid_code_error": "That code is invalid. Wait for a fresh code and try again.",
		"totp_disable_method_error": "This authenticator cannot authorize the change. Refresh Account and try again.",
		"totp_disable_title": "Disable two-factor authentication?",
		"totp_disabling": "Disabling...",
		"totp_empty": "No authenticator app is connected yet.",
		"totp_expired_error": "This setup has expired. Start again to generate a new QR code and setup key.",
		"totp_generic_error": "The authenticator could not be set up. Try again.",
		"totp_identity_required_error": "Add a verified email or linked sign-in method before enabling two-factor authentication.",
		"totp_invalid_code_error": "That code is invalid. Check your authenticator and try again.",
		"totp_load_error": "Authenticators could not be loaded.",
		"totp_loading": "Loading authenticators",
		"totp_manual_secret": "Manual setup key",
		"totp_name_description": "Optional. Use a name you will recognize later.",
		"totp_name_label": "Authenticator name",
		"totp_name_too_long": "Use 100 characters or fewer.",
		"totp_qr_alt": "Scan this QR code with your authenticator app",
		"totp_qr_loading": "Generating QR code",
		"totp_scan_description": "Scan the QR code, then enter the six-digit code shown by your authenticator app.",
		"totp_scan_title": "Connect your authenticator",
		"totp_secret_once": "This setup key is shown only during this enrollment.",
		"totp_set_up": "Set up authenticator",
		"totp_setup_description": "Give this authenticator an optional name before generating its one-time setup key.",
		"totp_setup_title": "Set up an authenticator",
		"totp_title": "Authenticator apps",
		"totp_unnamed_device": "Authenticator app",
		"totp_verified_on": "Verified {{date}}",
		"totp_verify": "Verify and enable",
		"totp_verifying": "Verifying...",
		"two_factor_disabled": "Not enabled",
		"two_factor_enabled": "Enabled",
		"two_factor_label": "Two-factor authentication"
	},
	"auth": {
		"back_to_login": "Back to sign in",
		"back_to_signup": "Back to registration",
		"backup_code": "Recovery code",
		"confirm_password": "Confirm password",
		"confirm_password_placeholder": "Repeat password",
		"confirm_password_required": "Confirm your password.",
		"continue_with": "Continue with {{provider}}",
		"email": "Email",
		"email_invalid": "Enter a valid email address.",
		"email_placeholder": "you@example.com",
		"email_required": "Enter your email address.",
		"forgot_code": "Code",
		"forgot_code_required": "Enter the code.",
		"forgot_description": "You will receive a one-time code if the address belongs to an account.",
		"forgot_new_password": "New password",
		"forgot_password": "Forgot password?",
		"forgot_request_submit": "Send the code",
		"forgot_reset_description_link": "Choose a new password for your account.",
		"forgot_reset_description_otp": "Enter the code you received and choose a new password.",
		"forgot_reset_submit": "Update password",
		"forgot_title": "Reset your password",
		"legal_and": "and",
		"legal_prefix": "By registering, you agree to the",
		"legal_privacy": "Privacy Policy",
		"legal_terms": "Terms",
		"login": "Sign in",
		"login_failed": "Provider sign-in was not completed. Try again.",
		"login_submit": "Sign in to the dashboard",
		"mfa_authenticator": "Authenticator",
		"mfa_description": "Choose one of the methods configured for your account.",
		"mfa_email": "Email",
		"mfa_passkey": "Passkey",
		"mfa_recovery": "Recovery",
		"mfa_title": "Two-step verification",
		"navigation": "Authentication",
		"or": "or",
		"password": "Password",
		"password_min": "At least 8 characters",
		"password_min_error": "Use at least 8 characters.",
		"password_mismatch": "The passwords do not match.",
		"password_required": "Enter your password.",
		"register_with": "Register with {{provider}}",
		"send_email_code": "Send code by email",
		"sign_in_with": "Sign in with {{provider}}",
		"signup": "Register",
		"signup_submit": "Start free",
		"subtitle": "API for the One Piece Card Game",
		"use_passkey": "Use passkey",
		"verify": "Verify",
		"verify_email_description": "Enter the 6-digit code sent to your address.",
		"verify_email_resend": "Send a new code",
		"verify_email_resend_cooldown": "Send a new code in {{seconds}}s",
		"verify_email_submit": "Verify and continue",
		"verify_email_title": "Verify your email"
	},
	"changelog": {
		"description": "The most important changes for everyone building with the SeaLedger API.",
		"entries": {
			"v1_2_0": {
				"item_1": "Account preferences and security.",
				"item_2": "Centralized API key management.",
				"item_3": "Improvements to the OpenAPI documentation.",
				"title": "Developer profile"
			},
			"v1_3_0": {
				"item_1": "Deck validation endpoint.",
				"item_2": "Filters for type, color, cost, and set.",
				"item_3": "Faster catalog searches.",
				"title": "Deck validation and expanded filters"
			},
			"v1_4_0": {
				"item_1": "Filter printings by language and market.",
				"item_2": "New fields for release status and upcoming editions.",
				"item_3": "Automatic printing-language recognition.",
				"title": "Complete multilingual support"
			}
		},
		"eyebrow": "Changelog",
		"title": "News and updates"
	},
	"dashboard": {
		"active": "Active",
		"analytics_error_description": "API key management and the other dashboard sections are still available.",
		"analytics_error_title": "Analytics are unavailable",
		"analytics_loading": "Loading analytics summary",
		"api_key_page": "Page {{page}} of {{total}}",
		"api_key_views": "API key views",
		"api_keys": "API keys",
		"api_keys_description": "Use them in the X-API-Key header. Secrets are shown only once.",
		"api_keys_error_description": "Your credentials could not be loaded. Try this section again.",
		"api_keys_error_title": "API keys are unavailable",
		"api_keys_loading": "Loading API keys",
		"average_latency": "Average latency",
		"billing_error_description": "Subscription details could not be loaded. Usage remains independent.",
		"billing_error_title": "Subscription is unavailable",
		"billing_loading": "Loading subscription",
		"billing_portal_failed": "Subscription management could not be opened.",
		"cancel": "Cancel",
		"copy_key": "Copy key",
		"create_key": "Create API key",
		"create_key_description": "Add a label that identifies where this credential will be used.",
		"create_key_title": "Create an API key",
		"creating_key": "Creating...",
		"dashboard_sections": "Dashboard sections",
		"duration": "Duration",
		"endpoint": "Endpoint",
		"errors": "4xx/5xx errors",
		"expired": "Expired",
		"free_plan": "Free plan",
		"generate_key": "Generate new",
		"key_copied": "Copied",
		"key_copy_failed": "The key could not be copied. Select it and copy it manually.",
		"key_create_failed": "The API key could not be created.",
		"key_create_failed_description": "Check the label or your active-key limit, then try again.",
		"key_created_description": "{{label}} is ready. Copy the secret before closing this dialog.",
		"key_created_title": "API key created",
		"key_name_description": "Use a recognizable label of up to 128 characters.",
		"key_name_label": "API key name",
		"key_name_placeholder": "Key name",
		"key_name_required": "Enter a name for this API key.",
		"key_name_too_long": "Use 128 characters or fewer.",
		"key_revoke_failed": "The selected API keys could not be revoked.",
		"key_revoked": "API key revoked.",
		"key_saved": "I've saved the key",
		"key_status_active": "active",
		"key_status_expired": "expired",
		"key_status_revoked": "revoked",
		"keys_revoked": "API keys revoked.",
		"latency_unavailable_description": "No successful requests to measure yet.",
		"latency_value": "{{value}} ms",
		"logs_error_description": "Recent requests could not be loaded. The other dashboard sections remain available.",
		"logs_error_title": "Recent logs are unavailable",
		"logs_loading": "Loading recent logs",
		"manage_subscription": "Manage subscription",
		"monthly_quota": "Monthly quota",
		"new_key_description": "Copy it now: it cannot be displayed again.",
		"next_page": "Next",
		"no_active_keys_description": "Name a credential to start connecting your integration.",
		"no_active_keys_title": "Create your first API key",
		"no_api_keys": "No API keys have been created.",
		"no_expired_keys_description": "Expired credentials will appear here as read-only history.",
		"no_expired_keys_title": "No expired API keys",
		"no_logs_description": "Your latest API calls will appear here as they arrive.",
		"no_logs_title": "No recent requests",
		"no_revoked_keys_description": "Keys you revoke will appear here as read-only history.",
		"no_revoked_keys_title": "No revoked API keys",
		"no_timeseries_description": "Requests will appear here after your API receives traffic.",
		"no_timeseries_title": "No request data yet",
		"not_available": "n/a",
		"overview": "Overview",
		"p95_latency": "p95 {{value}} ms",
		"p95_unavailable": "p95 unavailable",
		"plan": "Plan",
		"previous_page": "Previous",
		"quota_value": "{{used}} / {{limit}}",
		"rate_limited": "{{value}} rate limited",
		"recent_logs": "Recent logs",
		"remaining": "{{value}} remaining",
		"renewal": "Renews {{date}}",
		"requests_in_period": "{{value}} requests in this period",
		"requests_today": "Requests today",
		"retry": "Retry",
		"retrying": "Retrying...",
		"revoke": "Revoke",
		"revoke_all": "Revoke all",
		"revoke_all_description": "All active keys will be permanently revoked.",
		"revoke_description": "The key will be permanently revoked.",
		"revoke_key_label": "Revoke {{label}}",
		"revoke_title": "Confirm revocation",
		"revoked": "Revoked",
		"revoking": "Revoking...",
		"route_error_description": "The dashboard could not be displayed. Retry without losing your current session.",
		"route_error_title": "Dashboard unavailable",
		"seven_day_requests": "Requests in the last 7 days",
		"since": "since {{date}}",
		"status": "Status",
		"store_key_title": "Store this secret now",
		"subscription": "Subscription",
		"subtitle": "Monitor API activity, quota, and integration health.",
		"timeseries_error_description": "The seven-day request history could not be loaded.",
		"timeseries_error_title": "Request history is unavailable",
		"timeseries_label": "Request chart for the last seven days",
		"timeseries_loading": "Loading request history",
		"title": "Dashboard",
		"total_requests": "{{value}} total",
		"unavailable": "Unavailable",
		"usage": "Usage",
		"usage_error_description": "Quota and usage information could not be loaded.",
		"usage_error_title": "Usage is unavailable",
		"usage_loading": "Loading usage",
		"view_all": "View all",
		"view_logs": "View logs"
	},
	"description": "A simple home for developers who need credentials, visibility, and eventually a plan that fits their use.",
	"eyebrow": "Developer portal",
	"feature_billing_description": "Choose and manage a plan when billing is introduced.",
	"feature_billing_title": "Plans and billing",
	"feature_key_description": "Request and manage the credentials for your integration.",
	"feature_key_title": "API keys",
	"feature_usage_description": "See the information that matters for your integration.",
	"feature_usage_title": "Usage overview",
	"footer": {
		"changelog": "Changelog",
		"copyright": "© 2026 SeaLedger. All rights reserved.",
		"description": "The REST API for the One Piece Card Game. Built by collectors, for collectors.",
		"legal": "Legal",
		"made_for": "Made for card collectors.",
		"openapi": "OpenAPI spec",
		"privacy": "Privacy",
		"product": "Product",
		"resources": "Resources",
		"status": "Status page",
		"terms": "Terms"
	},
	"header": {
		"account": "Account",
		"dashboard": "Dashboard",
		"documentation": "Documentation",
		"language": "Language",
		"open_account_menu": "Open account menu",
		"open_navigation": "Open navigation",
		"pricing": "Pricing",
		"primary_navigation": "Primary navigation",
		"profile": "Profile",
		"retry_sign_out": "Retry sign out",
		"settings": "Settings",
		"sign_in": "Sign in",
		"sign_out": "Sign out",
		"sign_out_failed": "The session could not be closed.",
		"start_free": "Start free",
		"switch_language": "Switch to Italian"
	},
	"landing": {
		"account_deleted": "Your account has been closed and you have been signed out.",
		"api_example": "API response example",
		"cta_description": "Generate an API key and start building for the One Piece Card Game.",
		"cta_title": "Ready to build with SeaLedger?",
		"docs_code_comment": "// List all cards in a set",
		"docs_eyebrow": "Documentation",
		"docs_title": "A clean, predictable REST API.",
		"endpoint_card": "Complete details for one card and its localized effect.",
		"endpoint_cards": "List cards with filters for name, set, type, color, and rarity.",
		"endpoint_sets": "Released sets, release dates, and card totals.",
		"endpoint_validate": "Check whether a deck follows the format rules.",
		"faq_1_answer": "Yes. The Starter plan includes 100 requests per day, with no credit card required.",
		"faq_1_question": "Can I use the API for free?",
		"faq_2_answer": "Cards are available in English, Japanese, and French, with localized text and images.",
		"faq_2_question": "Which languages are supported?",
		"faq_3_answer": "The API returns 429 Too Many Requests and a Retry-After header indicating when to retry.",
		"faq_3_question": "What happens if I exceed the rate limit?",
		"faq_eyebrow": "FAQ",
		"faq_title": "Frequently asked questions",
		"feature_catalog_description": "Cards, sets, expansions, formats, and printings in one consistent structure.",
		"feature_catalog_title": "Complete catalog",
		"feature_rate_description": "Response headers always show how many requests your integration has left.",
		"feature_rate_title": "Transparent rate limits",
		"feature_webhook_description": "Receive events when new printings, sets, and errata are released.",
		"feature_webhook_title": "Real-time webhooks",
		"features_description": "Go from an idea to your first endpoint in minutes with normalized, documented data.",
		"features_eyebrow": "For developers",
		"features_title": "Less infrastructure. More product.",
		"hero_dashboard": "Go to Dashboard",
		"hero_description": "More than 1,800 cards, sets, leaders, and decks, all accessible through documented endpoints and fast JSON. Try it now with a free key.",
		"hero_eyebrow": "One Piece Card Game REST API",
		"hero_title_accent": "one call after another.",
		"hero_title_main": "The entire card universe,",
		"hero_try_api": "Try the API",
		"metrics_updated": "Data through {{date}}",
		"pricing_description_developer": "For production apps and active bots.",
		"pricing_description_enterprise": "For platforms and high volumes.",
		"pricing_description_starter": "For personal apps and prototypes.",
		"pricing_enterprise_price": "Contact us",
		"pricing_eyebrow": "Pricing",
		"pricing_item_daily_requests": "100 requests per day",
		"pricing_item_images_full": "Full-resolution images",
		"pricing_item_images_low": "Low-resolution images",
		"pricing_item_monthly_requests": "50,000 requests per month",
		"pricing_item_read": "Read endpoints",
		"pricing_item_read_validate": "Read and deck validation",
		"pricing_item_sla": "Dedicated SLA",
		"pricing_item_support": "Account manager",
		"pricing_item_unlimited": "Unlimited requests",
		"pricing_item_webhooks": "Real-time webhooks",
		"pricing_month": " / month",
		"pricing_popular": "Most popular",
		"pricing_select": "Choose {{name}}",
		"pricing_title": "A plan that grows with you.",
		"stat_average_latency": "average API latency (30 days)",
		"stat_catalog_printings": "catalog printings",
		"stat_requests_last_30_days": "API requests (30 days)"
	},
	"legal": {
		"eyebrow": "Legal",
		"last_updated": "Last updated: {{date}}.",
		"privacy": {
			"data": {
				"description": "We process the data needed to provide the portal: account identifiers, preferences, and technical request metadata. API keys are not shown again after they are created.",
				"title": "Data we process"
			},
			"purposes": {
				"description": "We use this data to authenticate your account, protect the service, apply usage limits, and provide support. We do not sell personal data or API secrets.",
				"title": "Purposes"
			},
			"retention_and_rights": {
				"description": "We retain data for as long as necessary for the stated purposes and legal obligations. You may request access, correction, or deletion through support.",
				"title": "Retention and rights"
			},
			"title": "Privacy Policy"
		},
		"terms": {
			"acceptable_use": {
				"description": "You may use the API for products and tools that comply with applicable law and the rights of content owners. You may not bypass limits, security controls, or access restrictions.",
				"title": "Acceptable use"
			},
			"access": {
				"description": "Access to the API requires a valid developer account. API keys are confidential credentials: keep them in a secrets manager and do not include them in repositories, URLs, or client applications.",
				"title": "Access to the service"
			},
			"availability": {
				"description": "The service is provided without a guarantee of uninterrupted availability. We may update endpoints, limits, and plans, communicating relevant changes in the changelog.",
				"title": "Availability"
			},
			"title": "Terms of Service"
		}
	},
	"logs": {
		"all_api_key_statuses": "All key states",
		"all_api_keys": "All API keys",
		"all_methods": "All methods",
		"all_statuses": "All statuses",
		"api_key": "API key",
		"api_key_label": "API key",
		"api_key_status_active": "Active",
		"api_key_status_expired": "Expired",
		"api_key_status_label": "API key state",
		"api_key_status_revoked": "Revoked",
		"duration": "Duration",
		"duration_value": "{{value}} ms",
		"empty": "No logs match the filters.",
		"endpoint": "Endpoint",
		"export_csv": "Export CSV",
		"export_filename": "sealedger-request-logs.csv",
		"eyebrow": "Monitoring",
		"filters_description": "Narrow the timeline with the signals that matter.",
		"filters_eyebrow": "Refine activity",
		"filters_label": "Request log filters",
		"load_more": "Load more",
		"method": "Method",
		"method_label": "Method",
		"not_available": "N/A",
		"requests_one": "{{formattedCount}} request",
		"requests_other": "{{formattedCount}} requests",
		"reset_filters": "Reset",
		"route_label": "API route",
		"status": "Status",
		"status_label": "Status",
		"subtitle": "Recent requests from your integration.",
		"time": "Time",
		"title": "Request logs"
	},
	"primary_action": "Request access",
	"private_area": {
		"error_description": "Your session or account details could not be checked. Retry to continue securely.",
		"error_title": "Account area unavailable"
	},
	"secondary_action": "How it works",
	"status": {
		"availability_check": "Global availability check.",
		"description": "Global status of SeaLedger's public infrastructure.",
		"eyebrow": "System status",
		"healthy_title": "All systems are operational.",
		"infrastructure": "SeaLedger infrastructure",
		"operational": "Operational",
		"unavailable": "Unavailable",
		"unavailable_title": "Status unavailable."
	},
	"title": "A clearer home for your API access."
}
